/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 13:54 22.04.2023
 * @ Description: class perement de géré les phrase ansi que de check les réponce
 */



import Word from "./word";
import WordButton from "../compenent/WordButton/WordButton";
import React from "react";

export default class Sentence{
    /**
     * Constructeur
     * @param {int} id id de la sentence (db)
     * @param {string} sentence sentence (string)
     * @param {SentenceError} errors erreurs de la sentences
     */
    constructor(id,sentence,errors){
        this.sentence=sentence;
        this.id=id;                           // id de la sentence, n'est utiliser que pour la page admin
        this.errors=errors;
        this.actualAnswerWord=[];            // Tous les mots que le joueur considère comme ça reponce
        this.words=this.getWords();
        this.correctionInfo=[0,0,0];           // info de la correction : 0 => correct, 1 => faux, 2 => miss
    }


    /**
     * Get every word in sentence
     * @returns array of Word objects
     */
    getWords(){
        let n=0;
        let wordCount=this.sentence.split(" ").length;          // nombre de mots dans la phrase (je peux pas utiliser juste ça, vue qu'il me faut égalment la start pos et la end pos)
        let words=[];

        for (let index = 0; index < wordCount; index++) {
            let n2=this.sentence.indexOf(' ',n);
            if(n2==-1){
                n2=this.sentence.length;
            }

            let wordText=this.sentence.substr(n,n2-n);
            words.push(new Word(wordText,n,n2));
            n=n2+1;
        }

        return words;
    }

    //#region Generate word button
    /**
     * génère les WordButton de tous les mots de la sentence
     * @param {int} fontSize font size des WordButton 
     * @returns liste de WordButton
     */
    generateWordButtons(fontSize=20){
        let wordButtons=[];
        for (let index = 0; index < this.words.length; index++) {
            const element = this.words[index];
            wordButtons.push(<WordButton sentence={this} word={element} fontSize={fontSize}/>)
        }
        return wordButtons;
    }

    /**
     * génère les WordButton de tous les mots de la sentence avec un onClick Custom et spécifiquement pour un bute administratife
     * @param {function} onClick on ButtonClick 
     * @param {int} fontSize font size des WordButton
     * @returns liste de WordButton
     */
    generateWordButtonsAdmin(onClick,fontSize=20){
        let wordButtons=[];

        // set up les actualAnserWord pour le but admin
        this.actualAnswerWord=[];

        for (let index = 0; index < this.words.length; index++) {
            const element = this.words[index];
            let isError=this.checkIfWordIsError(element);

            // si le mot est un erreur, l'ajoute déja dans les reponce
            if(isError)this.addAnswerWord(element);
            
            wordButtons.push(<WordButton sentence={this} select={this.checkIfWordIsError(element)} onClick={onClick} word={element} fontSize={fontSize}/>)
        }
        return wordButtons;
    }

    /**
     * Generate wordBotton pour les réponce
     * @param {int} fontSize 
     * @returns 
     */
    generateWordButtonsAnswer(fontSize=20){
        let wordButtons=[];
        for (let index = 0; index < this.words.length; index++) {
            const element = this.words[index];

            // get statue
            let state=2;
            if(this.checkIfWordIsError(element)){
                state=(this.actualAnswerWord.includes(element))?0:2;
            }
            else{
                state=(this.actualAnswerWord.includes(element))?1:4;
            }

            wordButtons.push(<WordButton endState={state} word={element} fontSize={fontSize}/>)
        }
        return wordButtons;
    }

    //#endregion

    /**
     * Check si le mot est une erreur ou pas
     * @param {Word} word 
     * @returns {bool}
     */
    checkIfWordIsError(word){
        for (let index = 0; index < this.errors.length; index++) {
            const element = this.errors[index];
            if(element.startPos==word.startPos && element.endPos==word.endPos){
                return true;
            }
        }
        return false;
    }

    /**
     * ajoute un mots dans le réponce du joueur
     * @param {Word} word 
     */
    addAnswerWord(word){
        if(!this.actualAnswerWord.includes(word)){
            this.actualAnswerWord.push(word);
        }
    }

    /**
     * enlève un mots des réponces du joueur
     * @param {Word} word 
     */
    removeAnswerWord(word){
        if(this.actualAnswerWord.includes(word)){
            this.actualAnswerWord.splice(this.actualAnswerWord.indexOf(word),1);
        }
    }

    /**
     * corrige la sentence, donne égalemnt le nombre de point optenue par le joueur
     * @returns nombre de point
     */
    correct(){
        // reste les correctio info 
        this.correctionInfo=[0,0,0];

        let point = 0;
        for (let index = 0; index < this.words.length; index++) {
            const element = this.words[index];
            let isSelect=(this.actualAnswerWord.includes(element));
            // get statue
            if(this.checkIfWordIsError(element)){
                point+=(isSelect)?10:0;          // correct => + 10 point  |  miss => + 0 point
                this.correctionInfo[(isSelect)?0:2]++;
            }
            else{
                point+=(isSelect)?-10:0;            // correct => - 10 point  |  none => + 0 point
                if(isSelect)this.correctionInfo[1]++;
            }
        }
        return point;
    }

}